module.exports = __webpack_public_path__ + "img/a_propos_mobile.caf23649.jpg";